import { render, staticRenderFns } from "./ExpedienteProductosActionsCellRenderer.vue?vue&type=template&id=4d078bc2"
import script from "./ExpedienteProductosActionsCellRenderer.vue?vue&type=script&lang=js"
export * from "./ExpedienteProductosActionsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports